export enum WalkSearchQueryQueryTypes {
  /**
   * Corresponds to {@link SearchComboType|SearchCombo} in *modules/workflows/types*.
   *
   * Contains a combinator and an array of search queries.
   */
  SearchCombo = 'searchCombo',
  /**
   * Corresponds to {@link DataTypeSearchCombo} in *modules/workflows/types*.
   *
   * Contains a data type and a {@link SearchComboType|SearchCombo}.
   */
  DataTypeCombo = 'dataTypeCombo',
  /**
   * Corresponds to {@link SearchQueryField} in *modules/workflows/types*.
   *
   * This should be the last level of the search query.
   */
  Field = 'field',
  /**
   * The query type cannot be determined.
   */
  Unknown = 'unknown',
}
